import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", {
  "data-segment": 1,
  class: "pi pi-ellipsis-v"
}, null, -1)
const _hoisted_11 = [
  _hoisted_10
]

import { ref, computed } from "vue";
import { useRouter } from "vue-router";

import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Menu from "primevue/menu";
import UsersHistoryDialog from "@/widgets/dialogs/UsersHistoryDialog.vue";

import { convertDateFromUTC } from "@/services/utils/DateParser";
import { getUserFullName } from "@/services/utils/Names";
import { useAuthStore } from "@/store/auth/login";


export default /*#__PURE__*/_defineComponent({
  __name: 'UsersTable',
  props: {
    users: {},
    isActiveFirst: { type: Boolean },
    isLoading: { type: Boolean },
    rowsCount: {}
  },
  emits: ["sortTable", "updateTable"],
  setup(__props: any, { emit: __emit }) {


const emits = __emit;
const router = useRouter();
const authStore = useAuthStore();

const isDenied = computed(() => {
  return authStore.isDeniedForPermissions(["history:edit"], ["history:read"]);
});

let modifiedId = ref(0);
const menu = ref();
const items = ref([
  {
    label: "История действий",
    icon: "pi pi-history",
    checkDenied: true,
    archive: "both",
    command: () => {
      confirmVisible.value.history = true;
    },
  },
  {
    label: "Редактировать",
    icon: "pi pi-pencil",
    archive: "no_archive",
    command: () => {
      router.push({ name: "user", params: { id: modifiedId.value } });
    },
  },
]);

const filteredItems = computed(() => {
  return items.value.filter((item) => !(item.checkDenied && isDenied.value));
});

const confirmVisible = ref({
  history: false,
});

const toggle = (elemId: number, event: any) => {
  modifiedId.value = elemId;
  menu.value.toggle(event);
};

const sortTable = (event: any) => {
  let orderField = "";
  if (event.sortField)
    orderField = event.sortOrder > 0 ? event.sortField : `-${event.sortField}`;
  emits("sortTable", orderField);
};

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(DataTable), {
      value: _ctx.users,
      class: _normalizeClass([[
      _ctx.users && _ctx.users.length == 0 ? 'empty-table' : '',
      _ctx.isActiveFirst ? 'active-first' : '',
    ], "scroll-table-y main-table scrollbar-custom"]),
      stripedRows: "",
      onSort: sortTable,
      removableSort: "",
      scrollable: "",
      loading: _ctx.isLoading,
      dataKey: "id",
      columnResizeMode: "expand"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Column), {
          field: "number",
          header: "№",
          style: {"min-width":"44px"}
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(_ctx.rowsCount + slotProps.index + 1), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "email",
          sortable: "",
          header: "Логин/почта"
        }, {
          body: _withCtx((slotProps) => [
            _createVNode(_component_RouterLink, {
              to: { name: 'user', params: { id: slotProps.data.id } }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(slotProps.data.email), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "lname",
          header: "Имя",
          sortable: ""
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(_unref(getUserFullName)(slotProps.data)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "organization",
          header: "Организация"
        }, {
          body: _withCtx((slotProps) => [
            (slotProps.data.role)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(slotProps.data.role.department.organization.name), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_2, "-"))
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "is_demo",
          header: "Демо-организация"
        }, {
          body: _withCtx((slotProps) => [
            (slotProps.data.role?.department?.organization?.is_demo)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Да"))
              : (_openBlock(), _createElementBlock("span", _hoisted_4, "Нет"))
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "department",
          header: "Департамент"
        }, {
          body: _withCtx((slotProps) => [
            (slotProps.data.role)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(slotProps.data.role.department.name), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_6, "-"))
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "role",
          header: "Роль"
        }, {
          body: _withCtx((slotProps) => [
            (slotProps.data.role)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(slotProps.data.role.name), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_8, "-"))
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "ctime",
          header: "Дата создания",
          sortable: "",
          style: {"min-width":"153px"}
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(_unref(convertDateFromUTC)(slotProps.data.ctime)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "mtime",
          header: "Дата обновления",
          sortable: "",
          style: {"min-width":"173px","max-width":"173px"}
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(_unref(convertDateFromUTC)(slotProps.data.mtime)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          frozen: "",
          alignFrozen: "right"
        }, {
          body: _withCtx((slotProps) => [
            _createElementVNode("div", {
              onClick: (event) => toggle(slotProps.data.id, event),
              "aria-haspopup": "true",
              "aria-controls": "overlay_menu",
              class: "button-menu"
            }, _hoisted_11, 8, _hoisted_9)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "class", "loading"]),
    _createVNode(_unref(Menu), {
      ref_key: "menu",
      ref: menu,
      id: "overlay_menu",
      model: filteredItems.value,
      popup: true
    }, null, 8, ["model"]),
    _createVNode(UsersHistoryDialog, {
      entity: "users",
      object_id: _unref(modifiedId),
      visible: confirmVisible.value.history,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (confirmVisible.value.history = false))
    }, null, 8, ["object_id", "visible"])
  ], 64))
}
}

})